import React, { useState } from 'react'
import { Actuator, ActuatorButton } from '../../models/smart-home.model'
import ActuatorBase from '../base/ActuatorBase'
import { Box, CircularProgress } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { J1DownArrowB, J1UpArrowB } from '@e3dc-react/icons'
import { useActuatorUpdate } from 'src/Libs/smart-home/hooks'
import ActuatorButtonGroup from 'src/Libs/smart-home/components/base/ActuatorButtonGroup'

interface Props {
  serialNo: number
  actuator: Actuator
}

const WindowBlinds: React.FC<Props> = ({ serialNo, actuator }) => {
  const { t } = useCustomTranslation()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const onUpdateActuator = useActuatorUpdate({ setIsLoading })

  const buttons: ActuatorButton[] = [
    {
      label: t('smart-home.actuator.window-blinds.open').toUpperCase(),
      onClick: () => onUpdateActuator(serialNo, actuator, { command: 'open' }, 0),
      dataQa: 'button-window-blinds-open',
    },
    {
      label: t('smart-home.actuator.window-blinds.up').toUpperCase(),
      onClick: () => onUpdateActuator(serialNo, actuator, { command: 'up' }, 0),
      dataQa: 'button-window-blinds-up',
      startIcon: <J1UpArrowB />,
      variant: 'outlined',
    },
    {
      label: t('smart-home.actuator.window-blinds.down').toUpperCase(),
      onClick: () => onUpdateActuator(serialNo, actuator, { command: 'down' }, 0),
      dataQa: 'button-window-blinds-down',
      startIcon: <J1DownArrowB />,
      variant: 'outlined',
    },
    {
      label: t('smart-home.actuator.window-blinds.close').toUpperCase(),
      onClick: () => onUpdateActuator(serialNo, actuator, { command: 'closed' }, 0),
      dataQa: 'button-window-blinds-close',
    },
  ]

  return (
    <ActuatorBase actuator={actuator} breakOnMobile>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexDirection: { xs: 'column', sm: 'row' } }}>
        {isLoading && <CircularProgress size={18} sx={{ top: '50%', left: '50%' }} />}
        <ActuatorButtonGroup buttons={buttons} />
      </Box>
    </ActuatorBase>
  )
}

export default WindowBlinds
